<template>
    <div>
        <div class="page-content">
            <transition name="fade" mode="out-in">
                <router-view>

                </router-view>
            </transition>
        </div>
    </div>
</template>

<script>

export default {
    components : {},
    data () {
    },
    metaInfo : {
        titleTemplate : '%s - Cyberfort',
        htmlAttrs     : {
            lang : 'en',
            amp  : true
        }
    },
    name : 'MainLayout'
};
</script>
